import { createFileRoute } from '@tanstack/react-router';

import { BookCallScreen } from '../../components/bookcall-screen';
import { getQueryClient } from '../../sdk/request';
import { getAuthUserFromCache } from '../../services/storage';
import {
  fetchOrganizationByIdImperative,
  useOrganizationById,
} from '../../services/storage/organizations-queries';

export const Route = createFileRoute('/app/bookcall/$orgId')({
  beforeLoad: function (args) {
    const { params } = args;
    const queryClient = getQueryClient();
    return Promise.allSettled([fetchOrganizationByIdImperative(queryClient, params.orgId)]);
  },
  // eslint-disable-next-line no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId } = Route.useParams() as unknown as { orgId: string };
  const queryClient = getQueryClient();
  // TanStack Query hooks
  const currentUser = getAuthUserFromCache(queryClient);
  const { data: currentOrg } = useOrganizationById(orgId);

  return (
    <BookCallScreen
      firstName={currentUser?.firstName}
      lastName={currentUser?.lastName}
      userEmail={currentUser?.email}
      companyUrl={currentOrg?.website}
    />
  );
}
